import { stats } from "../../data";

export default function StatsStrip({ bordered = false }) {
  return (
    <section className={bordered ? "border-b border-ink-700" : ""} data-testid="stats">
      <div className="grid grid-cols-2 md:grid-cols-4">
        {stats.map((s, i) => (
          <div
            key={s.code}
            className={`p-8 lg:p-12 ${i < stats.length - 1 ? "md:border-r" : ""} border-ink-700 ${
              i < 2 ? "border-b md:border-b-0" : ""
            } ${i === 1 ? "border-r md:border-r" : ""}`}
            data-testid={`stat-${s.code.toLowerCase()}`}
          >
            <p className="font-mono text-[10px] tracking-[0.24em] uppercase text-signal-phosphor mb-4">
              {s.code}
            </p>
            <p className="font-display font-black text-5xl lg:text-6xl text-textmain leading-none">
              {s.value}
            </p>
            <p className="mt-3 font-mono text-xs text-textmuted uppercase tracking-widest">
              {s.label}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
